// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WNdS","colBig":"styles_colBig__3ivbx","colSmall":"styles_colSmall__3WJ7O"};